import {
  DropdownMenuItem,
  menuItemFactory,
  permissionCheckItems,
} from 'layouts/AppPageTemplate/utils/menus';
import { User } from 'types/User';
import { Permission } from 'utils/permissions';
import { Routes } from '../../../constants/pages';

export const getSettingsMenuItems: (
  permissions: Permission[],
  user: User | null
) => DropdownMenuItem[] = (permissions, user) => {
  return permissionCheckItems(
    [
      {
        type: 'nested',
        title: 'Settings',
        children: [
          menuItemFactory(Routes.Profile),
          menuItemFactory(Routes.Plans),
          menuItemFactory(Routes.InvoiceHistory),
          menuItemFactory(Routes.RegionalNotificationSettings),
          menuItemFactory(Routes.RegionalCredentials),
        ],
      },
    ],
    permissions,
    user
  ) as DropdownMenuItem[];
};
